export default (_theme) => ({
    inline: {
        display: 'inline'
    },
    formLabel: {
        display: 'flex',
        alignItems: 'center'
    }
})
